export const mapBackendToFrontend = (data) => {
    return data.map((p, index) => {
        const isRugby = p.type === 'RUGBY';

        if (isRugby) {
            return {
                id: p.participantId,
                type: p.type,
                pseudo: p.pseudo,
                isMe: p.isMe,
                betAt: p.betAt,
                rank: p.rank ? p.rank : (index + 1),
                points: p.totalPoints || 0,

                winningTeamName: p.winningTeamName,
                winningTeamLogoUrl: p.winningTeamLogoUrl,
                predictionMargin: p.predictionMargin,
                odds: p.odds,

                betDisplay: p.winningTeamName
                    ? `${p.winningTeamName.substring(0, 3).toUpperCase()} +${p.predictionMargin}`
                    : `NUL`,

                maxPotentialPoints: p.maxPotentialPoints,
                pointsLostPerMarginUnit: p.pointsLostPerMarginUnit,

                quizBonus: p.quizBonus || 0,
                pronoPoints: (p.totalPoints || 0) - (p.quizBonus || 0),

                // Volet mi-temps (null si le joueur n'a pas joué la pause = marge HT null)
                halfTimeRank: p.halfTimeRank ?? null,
                halfTimePoints: p.halfTimePoints || 0,
                halfTimeQuizBonus: p.halfTimeQuizBonus || 0,
                halfTimeWinningTeamName: p.halfTimeWinningTeamName ?? null,
                halfTimePredictionMargin: p.halfTimePredictionMargin ?? null,
                betDisplayHalfTime: p.halfTimePredictionMargin != null
                    ? (p.halfTimeWinningTeamName
                        ? `${p.halfTimeWinningTeamName.substring(0, 3).toUpperCase()} +${p.halfTimePredictionMargin}`
                        : `NUL`)
                    : null,
            };
        }

        return {
            id: p.participantId,
            type: p.type,
            pseudo: p.pseudo,
            isMe: p.isMe,
            betHome: p.predictionHome,
            betAway: p.predictionAway,
            betDisplay: `${p.predictionHome}-${p.predictionAway}`,
            oddsWin: p.oddsWinner,
            oddsScore: p.oddsExactScore,
            points: p.totalPoints || 0,
            rank: p.rank ? p.rank : (index + 1),
            betAt: p.betAt,

            quizBonus: p.quizBonus || 0,
            pronoPoints: (p.totalPoints || 0) - (p.quizBonus || 0),

            // Volet mi-temps (null si le joueur n'a pas joué la pause)
            halfTimeRank: p.halfTimeRank ?? null,
            halfTimePoints: p.halfTimePoints || 0,
            halfTimeQuizBonus: p.halfTimeQuizBonus || 0,
            betHomeHalfTime: p.halfTimePredictionHome ?? null,
            betAwayHalfTime: p.halfTimePredictionAway ?? null,
            betDisplayHalfTime: (p.halfTimePredictionHome != null && p.halfTimePredictionAway != null)
                ? `${p.halfTimePredictionHome}-${p.halfTimePredictionAway}`
                : null,

            // Volet tirs au but (classement de la séance ; null/0 hors séance)
            penaltyRank: p.penaltyRank ?? null,
            penaltyScore: p.penaltyScore ?? 0,
            // Résultat par tir résolu (CORRECT / WRONG / ABSENT, dans l'ordre) pour les pastilles.
            penaltyKicks: p.penaltyKicks ?? [],
        };
    });
};